import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { ErrorBoundary } from './ErrorBoundary.js';
const LazySpatialAccelerated = React.lazy(async () => {
    const { SpatialWrapper } = await import('@vitessce/spatial-accelerated');
    return { default: SpatialWrapper };
});
export const SpatialAcceleratedAdapter = React.forwardRef((props, ref) => (_jsx("div", { ref: ref, style: { width: '100%', height: '100%' }, children: _jsx(ErrorBoundary, { fallback: _jsx("div", { children: "3D spatial view is not available in this environment." }), children: _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: _jsx(LazySpatialAccelerated, { ...props }) }) }) })));
//# sourceMappingURL=SpatialAcceleratedAdapter.js.map